export default __webpack_public_path__ + "static/media/icon_policy_overview_bottom2.839a4755.svg";